import "./editor.scss";
import "./style.scss";
import editf from "./edit.jsx";
import savef from "./save.jsx";
import json from "./block.json";

const { name, ...settings } = json;

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks

registerBlockType(name, {
	...settings,
	keywords: [
		__("superb rating block"),
		__("rating block"),
		__("review block"),
		__("rating bar"),
	],
	attributes: {
		maxRating: { type: "string", default: 5 },
		rating: { type: "string", default: 0 },
		ratingText: { type: "string", default: __("Overall Rating") },
		reviews: {
			type: "array",
			default: [{ title: "Rating Title", rating: 0.0 }],
		},
		useAverage: { type: "boolean", default: true },
		starAmount: { type: "number", default: 5 },
	},
	example: {
		attributes: {
			maxRating: 5,
			rating: 4.7,
			ratingText: "Overall Rating",
			reviews: [
				{ title: "Superb Blocks", rating: 5.0 },
				{ title: "SuperbThemes", rating: 5.0 },
				{ title: "Weather", rating: 4.3 },
			],
			useAverage: true,
			starAmount: 5,
		},
	},

	/**
	 * The edit function describes the structure of your block in the context of the editor.
	 * This represents what the editor will render when the block is used.
	 *
	 * The "edit" property must be a valid function.
	 *
	 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
	 *
	 * @param {Object} props Props.
	 * @returns {Mixed} JSX Component.
	 */
	edit: editf,

	/**
	 * The save function defines the way in which the different attributes should be combined
	 * into the final markup, which is then serialized by Gutenberg into post_content.
	 *
	 * The "save" property must be specified and must be a valid function.
	 *
	 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
	 *
	 * @param {Object} props Props.
	 * @returns {Mixed} JSX Frontend HTML.
	 */
	save: savef,
});
